import React, { useState, useEffect } from 'react';
import { getTodos } from '../../../utils/FamilyApiService';
import DragDropWeeklyTasks from '../DragDropWeeklyTasks/DragDropWeeklyTasks';
import './Todo.css';

const Todo = ({
    familyMemberName
}) => {

  return (
    <div className="todoConainer" style={{ color: familyMemberName === 'Jenny' ?  'orchid' : 'cornflowerblue' }}>
      <div>{familyMemberName}</div>
        <DragDropWeeklyTasks familyMemberName={familyMemberName} />
    </div>


  );
};

export default Todo;
